module.exports = __webpack_public_path__ + "static/media/harry.fe6f1ce1.jpeg";